import React from 'react'
import { toast } from 'react-toastify'
import { Success } from './components/Success'
import { Failure } from './components/Failure'

export interface Message {
  messageId?: string
  message?: string
}

/**
 * Shows a success toast notification
 */
export const toastSuccess = ({ messageId, message }: Message = {}) => {
  toast(() => (
    <Success
      messageId={messageId}
      message={message}
    />
  ), {
    draggable: true,
    draggablePercent: 50
  })
}

/**
 * Shows a failure toast notification
 */
export const toastFailure = ({ messageId, message }: Message = {}) => {
  toast(() => (
    <Failure
      messageId={messageId}
      message={message}
    />
  ), {
    draggable: true,
    draggablePercent: 50
  })
}
